import type {ReactNode} from "react";

export function AdminFormActions({
  children,
  left,
  className
}: {
  children: ReactNode;
  left?: ReactNode;
  className?: string;
}) {
  if(left != null) {
    return (
      <div className={`admin-form-actions admin-form-actions--split${className ? ` ${className}` : ""}`}>
        <div className="admin-form-actions__left">{left}</div>
        <div className="admin-form-actions__right">{children}</div>
      </div>
    );
  }
  return <div className={`admin-form-actions${className ? ` ${className}` : ""}`}>{children}</div>;
}
